import styled from 'styled-components';
import { P } from '../styled';
import Title from '../../../../components/Title';

export const HistoryIcon = styled.img`
  display: inline-block;
  height: 1.5em;
`

export const HistoryText = styled(Title)`
  font-size: 14px;
  display: inline-block;
  line-height: 1.5em;
  height: 1.5em;
  margin-left: 5px;
  color: black;
  margin-bottom: 0;
`
